export default __webpack_public_path__ + "static/media/Silk-Serif-Black-Italic.73bc2f9f.otf";